import {Component, Inject, OnInit, Optional} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TYPE_RUNNER_JOB_ID, TYPE_RUNNER_JOB_ID_LABELS } from 'src/app/app.models';
import { ConnectorZBEQuickActionsBottomSheetService } from '../zbe-quickactions-bottom-sheet/connector-zbe-quickactions-bottom-sheet.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { KendoModule } from 'src/app/kendo.module';
import { MaterialModule } from 'src/app/material.module';
import { CluBeSnackbarService } from '../../apps/@services/clube-snackbar.service';

@Component({
    selector: 'app-md-runner-task-sync-dialog',
    templateUrl: './md-runner-task-sync-dialog.component.html',
    standalone: true,
    imports: [CommonModule, KendoModule, MaterialModule, TranslateModule, TablerIconsModule, FormsModule, ReactiveFormsModule],
    providers: [ConnectorZBEQuickActionsBottomSheetService, CluBeSnackbarService]
})
export class MdRunnerTaskSyncDialogComponent implements OnInit {
    loading = false;
    errorText: string | null = null;
    aliases: any[] = [];
    formGroup = new FormGroup({
        TYPE_TASK: new FormControl(TYPE_RUNNER_JOB_ID.SAGE_100_C_SYNCHRONISATION_STRUCTURES, [Validators.required]),
        ALIAS_IDS: new FormControl(null, [Validators.required]),
        LIBELLE_TASK: new FormControl('Synchro. Sage ')
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) private dataE: any, 
        private connector : ConnectorZBEQuickActionsBottomSheetService,
        public dialogRef: MatDialogRef<MdRunnerTaskSyncDialogComponent>
    ) {
        if(!this.dataE) this.dataE = {};
        switch(this.dataE.TYPE_RUNNER_JOB_ID) {
            case 'SAGE_100_C_SYNCHRONISATION_STOCK' : this.formGroup.patchValue({ TYPE_TASK: TYPE_RUNNER_JOB_ID.SAGE_100_C_SYNCHRONISATION_STOCK, LIBELLE_TASK : 'Synchro. Stock Sage' }); break;
            default: break;
        }
    }

    ngOnInit() {
        this.doGetAdmPAliasesAction();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    async onSubmit() {
        if (this.formGroup.invalid) { return; }

        this.loading = true;
        this.formGroup.disable();
        let runnerTaskSaveDto = this.formGroup.value;
        try {
            const res = await this.connector.doSaveRunnerTasksAction_BOAdmSageLink(runnerTaskSaveDto);
            this.dialogRef.close(res);
        } catch(e: any) {
            this.errorText = e;
        }
        this.loading = false;
        this.formGroup.enable();
    }

    private async doGetAdmPAliasesAction() {
        this.loading = true;
        try {
            this.aliases = await this.connector.doGetAdmPAliasesAction_BOAdmAlias();
        } catch(e: any) {
            this.errorText = e;
        }
        this.loading = false;
    }
}